/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthNote } from './PalReauthNote';
import {
    PalReauthNoteFromJSON,
    PalReauthNoteFromJSONTyped,
    PalReauthNoteToJSON,
    PalReauthNoteToJSONTyped,
} from './PalReauthNote';

/**
 * 
 * @export
 * @interface PalReauthNoteHistoryResponse
 */
export interface PalReauthNoteHistoryResponse {
    /**
     * 
     */
    notes: Array<PalReauthNote>;
}

/**
 * Check if a given object implements the PalReauthNoteHistoryResponse interface.
 */
export function instanceOfPalReauthNoteHistoryResponse(value: object): value is PalReauthNoteHistoryResponse {
    if (!('notes' in value) || value['notes'] === undefined) return false;
    return true;
}

export function PalReauthNoteHistoryResponseFromJSON(json: any): PalReauthNoteHistoryResponse {
    return PalReauthNoteHistoryResponseFromJSONTyped(json, false);
}

export function PalReauthNoteHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthNoteHistoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'notes': ((json['notes'] as Array<any>).map(PalReauthNoteFromJSON)),
    };
}

export function PalReauthNoteHistoryResponseToJSON(json: any): PalReauthNoteHistoryResponse {
    return PalReauthNoteHistoryResponseToJSONTyped(json, false);
}

export function PalReauthNoteHistoryResponseToJSONTyped(value?: PalReauthNoteHistoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'notes': ((value['notes'] as Array<any>).map(PalReauthNoteToJSON)),
    };
}

